import React from "react";
import PictureUploadField from "../../PictureUploadField/PictureUploadField";
import qfStyles from "../QuickFormComponent.module.css";
import i18n from "../../../Services/i18n";
import DateTimePicker from "../../DateTimePicker/DateTimePicker";
import RichEditor from "../../RichEditor/RichEditor";
import { addToast } from "../../../Services/toastService";

class HorseQuickForm extends React.Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.pictureUploadFieldRef = React.createRef();
    this.state = {
      name: "",
      description: "",
      breed: "",
      coatColor: "",
      birthDate: "",
      sex: 0,
    };
  }

  handleChange = (field) => (eOrValue) => {
    const value = eOrValue && eOrValue.target !== undefined ? eOrValue.target.value : eOrValue;

    this.setState({ [field]: value });
  };

  isDirty = () => {
    const pictureFieldData = this.pictureUploadFieldRef.current?.getData?.();
    const hasPicture = !!pictureFieldData?.fileId;

    const hasTextValue = Object.values(this.state).some((value) => {
      if (typeof value !== "string") return false;
      return value.trim() !== "";
    });

    return hasTextValue || hasPicture;
  };

  validate = () => {
    if (this.state.name === "") {
      addToast(i18n.t("HorseForm.Validation.NameRequired"), "horseFormValidation", "ERROR");
      return false;
    }

    if (this.state.description.length > 40000) {
      addToast(
        i18n.t("ClientForm.Validation.InvalidDescriptionLen"),
        "clientFormValidationEmail",
        "ERROR",
      );
      return false;
    }

    return true;
  };

  getFormData = () => {
    const pictureFieldData = this.pictureUploadFieldRef.current.getData();
    return {
      clientExternalId: this.props.client.externalId,
      name: this.state.name,
      description: this.state.description,
      breed: this.state.breed,
      coatColor: this.state.coatColor,
      birthDate: this.state.birthDate,
      sex: this.state.sex ?? 0,
      defaultImageId: pictureFieldData.fileId,
    };
  };

  render() {
    return (
      <div className={qfStyles.container}>
        <div className={qfStyles.quickFormLeft}>
          <label readOnly className={qfStyles.quickFormLabel}>
            {i18n.t("HorseQuickForm.FieldClient")}
            <input
              type="text"
              className={`${qfStyles.quickFormInput} ${qfStyles.readOnlyInput}`}
              value={this.props.client.cardName}
              readOnly
            />
          </label>
          <label className={qfStyles.quickFormLabel}>
            {i18n.t("HorseQuickForm.FieldName")}
            <input
              type="text"
              className={qfStyles.quickFormInput}
              value={this.state.name}
              maxLength={200}
              onChange={this.handleChange("name")}
            />
          </label>
          <div className={qfStyles.inlineFields}>
            <label className={`${qfStyles.quickFormLabel} ${qfStyles.inlineField}`}>
              {i18n.t("Generic.Breed")}
              <input
                type="text"
                className={qfStyles.quickFormInput}
                value={this.state.breed}
                maxLength={256}
                onChange={this.handleChange("breed")}
              />
            </label>
            <label className={`${qfStyles.quickFormLabel} ${qfStyles.inlineField}`}>
              {i18n.t("Generic.CoatColor")}
              <input
                type="text"
                className={qfStyles.quickFormInput}
                value={this.state.coatColor}
                maxLength={256}
                onChange={this.handleChange("coatColor")}
              />
            </label>
          </div>

          <div className={qfStyles.inlineFields}>
            <label className={`${qfStyles.quickFormLabel} ${qfStyles.inlineField}`}>
              {i18n.t("Generic.BirthDate")}
              <DateTimePicker
                name="birthdate"
                value={this.state.birthDate}
                onChange={this.handleChange("birthDate")}
                readOnly={false}
                includeTime={false}
                showAgeBox={true}
              />
            </label>
            <div className={`${qfStyles.formGroup} ${qfStyles.inlineField}`}>
              <label className={qfStyles.quickFormLabel} style={{ margin: "0px" }}>
                {i18n.t("Generic.Sex")}
              </label>
              <select
                value={this.state.sex}
                onChange={this.handleChange("sex")}
                className={qfStyles.quickFormSelect}>
                <option value={0}>{i18n.t("Generic.Sex.Undefined")}</option>
                <option value={1}>{i18n.t("Generic.Sex.Guelding")}</option>
                <option value={2}>{i18n.t("Generic.Sex.Female")}</option>
                <option value={3}>{i18n.t("Generic.Sex.Male")}</option>
              </select>
            </div>
          </div>
          <label className={qfStyles.quickFormLabel}>
            {i18n.t("HorseQuickForm.FieldDescription")}
          </label>
          <RichEditor
            controlled
            value={this.state.description}
            onChange={(html) => {
              this.setState({ description: html });
            }}
            placeholder={""}
            height={300}
            showEmoji
            showTextColor
            showFontSize
            showBold
            showItalic
            showUnderline
            showStrikethrough
          />
        </div>
        <div className={qfStyles.quickFormRight}>
          <PictureUploadField
            ref={this.pictureUploadFieldRef}
            clientThumbnail={this.props.client.defaultImage}
            clientThumbnailFileId={this.props.client.defaultImageId}
          />
        </div>
      </div>
    );
  }
}

export default HorseQuickForm;
